export { ErrorBoundaryWrapper as ErrorBoundary } from './ErrorBoundary'
